/* tslint:disable */
/* eslint-disable */
/**
 * ISO Backend Modules API
 * ISO API for the IBE.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ApiFilterCategory;
(function (ApiFilterCategory) {
    ApiFilterCategory["PRICERANGE"] = "PRICE_RANGE";
    ApiFilterCategory["CHARACTERISTICS"] = "CHARACTERISTICS";
    ApiFilterCategory["CATEGORY"] = "CATEGORY";
    ApiFilterCategory["THEMES"] = "THEMES";
    ApiFilterCategory["SERVICEOPTIONS"] = "SERVICE_OPTIONS";
    ApiFilterCategory["SERVICETYPE"] = "SERVICE_TYPE";
    ApiFilterCategory["DURATION"] = "DURATION";
    ApiFilterCategory["NUMBEROFSTOPS"] = "NUMBER_OF_STOPS";
    ApiFilterCategory["AIRLINES"] = "AIRLINES";
    ApiFilterCategory["SUPPLIER"] = "SUPPLIER";
    ApiFilterCategory["AIRCONDITION"] = "AIR_CONDITION";
    ApiFilterCategory["TRANSMISSION"] = "TRANSMISSION";
    ApiFilterCategory["FUELTYPE"] = "FUEL_TYPE";
    ApiFilterCategory["SEATSCOUNT"] = "SEATS_COUNT";
    ApiFilterCategory["BAGSCOUNT"] = "BAGS_COUNT";
    ApiFilterCategory["DOORSCOUNT"] = "DOORS_COUNT";
    ApiFilterCategory["LOCATION"] = "LOCATION";
    ApiFilterCategory["TIMES"] = "TIMES";
    ApiFilterCategory["SUBCATEGORY"] = "SUBCATEGORY";
    ApiFilterCategory["DISTANCELIMIT"] = "DISTANCE_LIMIT";
    ApiFilterCategory["BEDSCOUNT"] = "BEDS_COUNT";
    ApiFilterCategory["UNITTYPE"] = "UNIT_TYPE";
    ApiFilterCategory["DEPARTUREAIRPORT"] = "DEPARTURE_AIRPORT";
    ApiFilterCategory["DESTINATION"] = "DESTINATION";
})(ApiFilterCategory || (ApiFilterCategory = {}));
function ApiFilterCategoryFromJSON(json) {
    return ApiFilterCategoryFromJSONTyped(json);
}
function ApiFilterCategoryFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ApiFilterCategoryToJSON(value) {
    return value;
}

export { ApiFilterCategory, ApiFilterCategoryFromJSON, ApiFilterCategoryFromJSONTyped, ApiFilterCategoryToJSON };
//# sourceMappingURL=ApiFilterCategory.js.map
